import { formActionTypes as actionTypes } from "../ActionTypes/formActionTypes";
import {commonActionTypes} from "../ActionTypes/commonActionTypes";

export const initialState = {
    forms: []
};

export default function FormReducer(state = initialState, action) {
    let newState;
    
    switch (action.type) {
        case actionTypes.START_FORM_EDITING:
            newState = {
                ...state,
                forms: {
                    ...state.forms,
                    [action.id]: {
                        id: action.id,
                        data: action.data,
                        validationRules: action.validationRules,
                        fieldTypes: action.fieldTypes,
                        fieldErrorFlags: []
                    }
                }
            };
            break;
        case commonActionTypes.CANCEL_EDITING_FORM:
        case actionTypes.CANCEL_FORM_EDITING:
            newState = {forms: {...state.forms}}
            delete newState.forms[action.formId]
            break;
        case actionTypes.CHANGE_FIELD_VALUE:
            const updatedForm = {
                ...state.forms[action.id],
                data: {
                    ...state.forms[action.id].data,
                    [action.field]: action.value
                }
            };

            newState = {
                ...state,
                forms: {
                    ...state.forms,
                    [action.id]: updatedForm
                }
            };
            break;
        case actionTypes.UPDATE_FORM_VALIDITY:
            newState = {
                ...state,
                forms: {
                    ...state.forms,
                    [action.id]: {
                        ...state.forms[action.id],
                        valid: action.valid,
                        fieldErrorFlags: action.fieldErrorFlags
                    }
                }
            };
            break;
        case actionTypes.UPDATE_FORM_VALIDATION_RULES:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.id]: {
                        ...state.forms[action.id],
                        validationRules: action.validationRules
                    }
                }
            };
        default:
            return state;
    }

    return newState;
}